import type { ConfirmRoundRecapAction } from "../types/action";
import type { HorrorRaceState } from "../types/game-state";

export function applyConfirmRoundRecap(
  state: HorrorRaceState,
  action: ConfirmRoundRecapAction,
): HorrorRaceState {
  const updatedPlayers = state.players.map((player) => {
    if (player.id !== action.playerId) {
      return player;
    }
    return { ...player, hasConfirmedRoundRecap: true };
  });

  return {
    ...state,
    players: updatedPlayers,
  };
}
